import { useEffect, useRef, useState } from 'react';

import { ProcessBarStyled } from './styled';

import workLottie from 'src/animation/workout-lottie.json';

import clsx from 'clsx';
import lottie from 'lottie-web';
import { IRobot } from 'src/types/firebase';

interface ProcessBarProps {
  className?: string;
  robot?: IRobot;
}

const ProcessBar = ({ className, robot }: ProcessBarProps) => {
  const animationContainer = useRef(null);
  const [update, setUpdate] = useState(false);
  const set = robot?.set || 1;
  useEffect(() => {
    if (animationContainer.current && !update) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: workLottie,
      });

      setUpdate(true);
    }
  }, [animationContainer.current]);

  return (
    <ProcessBarStyled className={clsx('RestAnimation', className)}>
      <div className="animation" ref={animationContainer}></div>
      <div className="message">
        {set} 세트 운동중 입니다. <br /> 목표치를 달성해 보세요!
      </div>
    </ProcessBarStyled>
  );
};

export default ProcessBar;
